export default "__VITE_ASSET__f0e6a5a7__"